import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import axios from "axios";
import { NuevaAxiosURL } from "../../../utils/utils";
import MobileInput from "../../Mobile/Inputs/MobileInput";
import MobileButton from "../../Mobile/Buttons/MobileButton";
import MobileModal from "../../Mobile/Modal/MobileModal";
import BackButton from "../../ui/BackButton/BackButton";
import ElevvaLogo from "../../Mobile/Elements/ElevvaLogo";
import "./RecoverPassword.css";
import "../Login/Login.css"; // Reuse Login styles for absolute consistency

const RecoverPassword = ({ elevvaT = (key) => key }) => {
    const navigate = useNavigate();
    const [displayLoading, setDisplayLoading] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        title: "",
        description: "",
        icon: null,
        actions: []
    });

    const closeModal = () => {
        setModalConfig(prev => ({ ...prev, isOpen: false }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const email = event.target.mail.value.trim();
        setDisplayLoading(true);

        const formData = new FormData();
        formData.append("email", email);

        axios.post(`${NuevaAxiosURL}users/auth/forgot-password/`, formData)
            .then((res) => {
                const data = res.status;
                if (data === 200 || data === 202) {
                    setModalConfig({
                        isOpen: true,
                        title: "¡Correo enviado!",
                        description: "Hemos enviado tu nueva contraseña a tu correo electrónico.",
                        iconType: "check",
                        actions: [{
                            text: "Entendido",
                            onClick: () => {
                                closeModal();
                                navigate("/");
                            }
                        }]
                    });
                }
            })
            .catch((err) => {
                setModalConfig({
                    isOpen: true,
                    title: "Error",
                    description: "El correo no se encuentra registrado.",
                    iconType: "infoError",
                    actions: [{
                        text: "Entendido",
                        onClick: closeModal,
                    }]
                });
            })
            .finally(() => {
                setDisplayLoading(false);
            });
    };

    return (
        <>
            <MobileModal {...modalConfig} onClose={closeModal} />

            <div>
                <div className="d-flex flex-column align-items-center w-100 gap-3">
                    <div className="w-100 mb-4 animate-fade-in-up">
                        <div className="auth-header-flex">
                            <div className="auth-nav-area">
                                <BackButton />
                            </div>
                            <h1 className="auth-main-title">Recuperar contraseña</h1>
                            <div className="auth-nav-area hidden"></div>
                        </div>
                        <div className="recover-accent-line mx-auto"></div>
                    </div>

                    <p className="mobile-login-description mb-0 animate-fade-in-up delay-1">
                        Introduce el correo electrónico en el que quieres recibir la información para cambiar tu contraseña.
                    </p>

                    <form className="w-100 d-flex flex-column gap-3 animate-fade-in-up delay-2 mt-2" onSubmit={handleSubmit}>
                        <MobileInput
                            type="email"
                            name="mail"
                            label="Correo electrónico"
                            placeholder="ejemplo@correo.com"
                            required
                        />

                        {displayLoading ? (
                            <div className="d-flex justify-content-center my-2">
                                <HashLoader color="#394F65" size={30} />
                            </div>
                        ) : (
                            <MobileButton
                                text="Enviar"
                                type="submit"
                                className="mt-3"
                            />
                        )}
                    </form>
                </div>
            </div>
        </>
    );
};

export default React.memo(RecoverPassword);
